export default {
  back: window.VK_BACK,
  navigation: {
    left: window.VK_LEFT,
    up: window.VK_UP,
    right: window.VK_RIGHT,
    down: window.VK_DOWN,
    enter: window.VK_ENTER,
  },
  mediaControl: {
    play: window.VK_PLAY,
    pause: window.VK_PAUSE,
    stop: window.VK_STOP,
    playPause: window.VK_PLAY_PAUSE,
    fastForward: window.VK_FAST_FWD,
    rewind: window.VK_REWIND,
  },
  channel: {
    up: window.VK_CHANNEL_UP,
    down: window.VK_CHANNEL_DOWN,
  },
  color: {
    red: window.VK_RED,
    green: window.VK_GREEN,
    yellow: window.VK_YELLOW,
    blue: window.VK_BLUE,
  },
  numbers: [
    window.VK_0,
    window.VK_1,
    window.VK_2,
    window.VK_3,
    window.VK_4,
    window.VK_5,
    window.VK_6,
    window.VK_7,
    window.VK_8,
    window.VK_9,
  ],
};
